export default "__VITE_ASSET__DYCj0sjE__"